import { FormHelpers } from 'utility/form-helpers'
import { CheckCircleHollowIcon, WarningIcon } from '../icons'
import { Toasts } from './toasts'

export const AccountSalesForm = (target: HTMLFormElement) => {
  const el = {
    root: target,
    inputs: target.querySelectorAll<HTMLInputElement>('input'),
    button: target.querySelector<HTMLButtonElement>('.button[type="submit"]'),
  }

  const method = {
    init: () => {
      if (!el.inputs || !el.button) return
      el.root.addEventListener('submit', method.onSubmit)
    },

    onSubmit: (e: Event & { target: HTMLFormElement }) => {
      e.preventDefault()

      if (!el.inputs.length) return

      FormHelpers.submitForm({
        form: e.target,
        buttons: [el.button],
        onSuccess: ({ message = '', redirectUrl }) => {
          el.inputs.forEach((input) => {
            input.value = ''
            input.checked = false
          })
          Toasts.addToast({
            title: 'Umsókn móttekin!',
            text: message || '',
            icon: CheckCircleHollowIcon(),
          })
          if (
            redirectUrl &&
            typeof redirectUrl === 'string' &&
            redirectUrl.trim() !== ''
          ) {
            setTimeout(() => {
              // Redirect the user after 3 seconds.
              window.location.href = redirectUrl
            }, 3000) // 3000 milliseconds = 3 seconds
          }
        },
        onError: (message = '') =>
          Toasts.addToast({
            title: 'Villa kom upp!',
            text: message || 'Úps, villa kom upp.',
            icon: WarningIcon(),
          }),
      })
    },
  }

  method.init()
}
